<template>
<div @click="anyesc">

  <vue-scroll :class="{active: showActive}" >
    <div class="app">
      <!-- <Home ref="home" @showflag="showflag" v-if="flag"/> -->
      <router-view></router-view>
    </div>
  </vue-scroll>
</div>
</template>

<script>
// import Home from "./components/Home";
export default {
  name: "App",
  // components: { Home },
  data(){
    return{
      showActive:false,
      a:0
    }
  },
  provide() {
    return {
      reload: this.reload,
    };
  },
  methods: {
   reload() {
    this.a++
     if(this.a%2==0){
       this.showActive = false
       return
     }
     this.showActive = true
    },
    
    // showflag(a){
    //   //当点击下载时,让模板展示
    //     this.showActive = a      
    // },
    // 点击任意一处让蒙版消失
    anyesc(){
      this.a = 0
        this.showActive = false
  
    }
  },
  // watch:{
  //     $route: {
  //       immediate:true,
  //     deep: true,
  //     handler(value) {
  //       console.log(value)
  //     },
  //   },
  // }
};
</script>

<style lang="less" scoped >
.__vuescroll {
    background: linear-gradient(20deg, #0034cb, #0e7dd7);
}
.active::after{
    content:'';
    display: block;
    background: rgba(0, 0, 0, 0.6);
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    pointer-events:none;
    z-index: 99;
}
.active::before{
  display: block;
  content:'';
  position: absolute;
    width: 120px;
  height: 95px;
  right: 17px;
  top: 0px;
  background: url('./assets/day1_slices/提示图片@2x.png') no-repeat;
  background-size: cover;
  z-index: 100;
}

::v-deep .__view{
  height: 100vh;
}
  .app {
  height: 100%;
  width: 100%;

}


</style>